// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dhnqqrrknxqqpfxleldo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRobnFxcnJrbnhxcXBmeGxlbGRvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU4MzQ4NTAsImV4cCI6MjA3MTQxMDg1MH0.sT0wFxa-A1b5yuSxzbkOPA0KlMsHU300cJfY80MWjWE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});